import { configureStore } from '@reduxjs/toolkit';

import {auth, user, websocket, message } from '../features/network/networkSlice';
import { fileUpload } from '../features/file-upload/fileUploadSlice';
import { processLogs, process } from '../features/process/processSlice';
import { menu, workfront, runtime, stepaction } from '../features/menu/menuSlice';
import { form } from '../features/form/formSlice';
import { xeditor } from '../features/xeditor/xeditorSlice';
import { catalog } from '../features/media/catalogSlice';
import { workflow } from '../features/workflow/workflowSlice';
import { documentConfig } from '../features/management/managementSlice';

export default configureStore({
  reducer: {
    auth: auth.reducer,
    user: user.reducer,
    menu: menu.reducer,
    workfront: workfront.reducer,
    runtime: runtime.reducer,
    form: form.reducer,
    websocket: websocket.reducer,
    fileUpload: fileUpload.reducer,
    processLogs: processLogs.reducer,
    process: process.reducer,
    stepaction: stepaction.reducer,
    xeditor: xeditor.reducer,
    catalog: catalog.reducer,
    message: message.reducer,
    workflow: workflow.reducer,
    documentConfig: documentConfig.reducer,
  },
});

